<template>
  <div>
    <div id="header-info">
      <div class="topbar">
        <topbar />
      </div>
      <div>
        <search @search="search" />
      </div>
    </div>
    <div>
      <app-nav />
    </div>
    <div>
      <cart-side />
    </div>
    <div v-if="isShowModel" class="model-QRCode">
      <div class="close-model"><span @click="closeModel">X</span></div>
      <p style="margin-top:60px;">请使用微信扫描二维码 </p>
      <img :src="imgurl" alt="付款码">
    </div>
    <div id="current-order">
      <div id="current-order-header">
        <p>感谢你！订单提交成功。</p>
        <router-link to="/orders"><b-button>查看订单</b-button></router-link>
        <router-link to="/order"><b-button variant="danger">继续购物</b-button></router-link>
      </div>
      <order-info :orders="orderList" @showModal="showCode" />
    </div>
    <div>
      <app-footer />
    </div>
  </div>
</template>
<script>
import OrderInfo from './OrderInfo'
import footer from '@/components/Footer.vue'
import CartSide from '../item/CartSide'
import topbar from '@/components/TopBar.vue'
import search from '@/components/Search.vue'
import nav from '@/components/Nav.vue'
import { OrderService } from '@/service/OrderService'
export default {
  components: {
    'app-nav': nav, 'order-info': OrderInfo,
    search, topbar, 'app-footer': footer, 'cart-side': CartSide
  },
  data () {
    return {
      isShowModel: false,
      imgurl: '',
      fields: [
        { key: 'image', label: '图片' }, { key: 'name', label: '通用名/商品名' },
        { key: 'norm', label: '规格' }, { key: 'maker', label: '生产厂家' },
        { key: 'licenseNumber', label: '批准文号' }, { key: 'largeScale', label: '大包装' },
        { key: 'lotNumber', label: '批号' }, { key: 'expiryTime', label: '有效期至' },
        { key: 'basicUnit', label: '单位' }, { key: 'showPrice', label: '单价' },
        { key: 'num', label: '数量' }, { key: 'count', label: '小计' },
        '资质文件'
      ],
      orderList: []
    }
  },
  mounted () {
    document.scrollTop = 0
    document.documentElement.scrollTop = 0
  },
  beforeRouteEnter (to, from, next) {
    var ids = to.params.orderIds
    next(vm => {
      vm.fetchData(ids)
    })
  },
  methods: {
    search () {

    },
    showCode (url) {
      this.isShowModel = true
      this.imgurl = process.env.VUE_APP_API + 'hy-sb-order/' + url
      this.setTime()
    },
    closeModel () {
      this.isShowModel = false
      clearInterval(this.limitTime)
      this.$router.push({ name: 'orders' })
    },
    setTime () {
      clearInterval(this.limitTime)
      let time = 60
      this.limitTime = setInterval(() => {
        if (time <= 0) {
          this.closeModel()
        } else {
          time--
        }
      }, 1000)
    },
    fetchData (ids) {
      const Order = new OrderService(this.$axios)
      Order.loadCurrentOrders(ids).then((order) => {
        console.log(order, 'item11222')
        this.orderList = order
      })
    }
  }
}
</script>
<style>
  #current-order {
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;
    font-size: 0.75rem;
  }
  #current-order-header {
    padding: 5px 0;
    border-bottom: 1px solid #939393;
  }
  #current-order-header p{
    margin-bottom: 10px;
    font-size: 1.125rem;
    line-height: 1.25rem;
  }
  #current-order-header .btn {
    width: 164px;
    height: 40px;
    padding: 0;
    border: 0;
    font-size: 1.215rem;
  }
  #current-order-header .btn-secondary {
    color: #000;
    background-color: #e0e0e0;
    margin-right: 25px;
  }
  #current-order-header .btn-danger {
    background-color: #df3033;
  }
  .model-QRCode {
    position:fixed;
    width: 300px;
    height: 300px;
    top:50%;
    margin-top: -150px;
    margin-left: -150px;
    left:50%;
    background-color: #fff;
    text-align: center;
  }
  .close-model {position:relative;}
  .close-model span {
    position: absolute;
    right: 10px;
    top:10px;
    border: 1px solid #ccc;
    width: 40px;
    text-align: center;
    line-height: 40px;
    height: 40px;
    border-radius: 50%;
    cursor:pointer;
  }
  .model-QRCode img {
    width: 200px;
    height: 200px;
  }
</style>
